import React from 'react';

export interface ErrorProps {
  error: string;
}

export const Error = ({ error }: ErrorProps) => <p className="info error">{error}</p>;
